/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CatalogDeprecateRequest,
  CatalogImpactResponse,
  CatalogModelCreate,
  CatalogModelUpdate,
  CatalogModelView,
  CatalogProbeRequest,
  CatalogProbeResponse,
  CatalogResponse,
  ConnectionAdminItem,
  ConnectionAdminListResponse,
  CreateGithubConnectionRequest,
  CreateS3ConnectionRequest,
  CreateS3RoleConnectionRequest,
  CreateTeamRequest,
  DeleteTeamApiInternalTeamsTeamIdDeleteParams,
  DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete200,
  DreamScanStatusResponse,
  FallbackOptionsResponse,
  GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
  GithubAppStatus,
  HTTPValidationError,
  ImpersonatableTeam,
  JobStartedResponse,
  JobStoppedResponse,
  ModelAliasCreate,
  ModelCreate,
  ModelResponse,
  ModelUpdate,
  PingResponse,
  PipelineGrantItem,
  PipelineGrantListResponse,
  PipelineRegistryResponse,
  PlatformGithubAppInstallationsResponse,
  PlatformGithubAppView,
  SavePlatformGithubAppRequest,
  SaveTeamEvalsConfigRequest,
  TeamBillingAdminResponse,
  TeamDeletePreview,
  TeamDeleteResult,
  TeamEvalsConfigResponse,
  TeamJobListResponse,
  TeamJobLogResponse,
  TeamJobRunRequest,
  TeamListResponse,
  TeamModelsAdminResponse,
  TrainingPresetsResponse,
  UpdateTeamEmailDomainsRequest,
  UpdateTeamNavRequest,
  WorldJudgeResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type pingApiInternalPingGetResponse200 = {
  data: PingResponse;
  status: 200;
};

export type pingApiInternalPingGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type pingApiInternalPingGetResponseSuccess =
  pingApiInternalPingGetResponse200 & {
    headers: Headers;
  };
export type pingApiInternalPingGetResponseError =
  pingApiInternalPingGetResponse422 & {
    headers: Headers;
  };

export type pingApiInternalPingGetResponse =
  | pingApiInternalPingGetResponseSuccess
  | pingApiInternalPingGetResponseError;

export const getPingApiInternalPingGetUrl = () => {
  return `/api/internal/ping`;
};

/**
 * Smoke-test endpoint guarded by the employee tier.
 *
 * Returns 200 for trainloop.ai emails, 403 for everyone else.
 * @summary Ping
 */
export const pingApiInternalPingGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<pingApiInternalPingGetResponse> => {
  return orvalFetch<pingApiInternalPingGetResponse>(
    getPingApiInternalPingGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getPingApiInternalPingGetQueryKey = () => {
  return [`/api/internal/ping`] as const;
};

export const getPingApiInternalPingGetQueryOptions = <
  TData = Awaited<ReturnType<typeof pingApiInternalPingGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof pingApiInternalPingGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPingApiInternalPingGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof pingApiInternalPingGet>>
  > = ({ signal }) => pingApiInternalPingGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof pingApiInternalPingGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PingApiInternalPingGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof pingApiInternalPingGet>>
>;
export type PingApiInternalPingGetQueryError = ErrorType<HTTPValidationError>;

export function usePingApiInternalPingGet<
  TData = Awaited<ReturnType<typeof pingApiInternalPingGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof pingApiInternalPingGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pingApiInternalPingGet>>,
          TError,
          Awaited<ReturnType<typeof pingApiInternalPingGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePingApiInternalPingGet<
  TData = Awaited<ReturnType<typeof pingApiInternalPingGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof pingApiInternalPingGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pingApiInternalPingGet>>,
          TError,
          Awaited<ReturnType<typeof pingApiInternalPingGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePingApiInternalPingGet<
  TData = Awaited<ReturnType<typeof pingApiInternalPingGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof pingApiInternalPingGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Ping
 */

export function usePingApiInternalPingGet<
  TData = Awaited<ReturnType<typeof pingApiInternalPingGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof pingApiInternalPingGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPingApiInternalPingGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listAllTeamsApiInternalTeamsGetResponse200 = {
  data: TeamListResponse;
  status: 200;
};

export type listAllTeamsApiInternalTeamsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listAllTeamsApiInternalTeamsGetResponseSuccess =
  listAllTeamsApiInternalTeamsGetResponse200 & {
    headers: Headers;
  };
export type listAllTeamsApiInternalTeamsGetResponseError =
  listAllTeamsApiInternalTeamsGetResponse422 & {
    headers: Headers;
  };

export type listAllTeamsApiInternalTeamsGetResponse =
  | listAllTeamsApiInternalTeamsGetResponseSuccess
  | listAllTeamsApiInternalTeamsGetResponseError;

export const getListAllTeamsApiInternalTeamsGetUrl = () => {
  return `/api/internal/teams`;
};

/**
 * List every team on the platform, for the staff impersonation picker.
 *
 * Staff-only. Returns all Keycloak groups; the client uses these ids/names
 * as the `X-Impersonate-Team` value when entering impersonation.
 * @summary List All Teams
 */
export const listAllTeamsApiInternalTeamsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listAllTeamsApiInternalTeamsGetResponse> => {
  return orvalFetch<listAllTeamsApiInternalTeamsGetResponse>(
    getListAllTeamsApiInternalTeamsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAllTeamsApiInternalTeamsGetQueryKey = () => {
  return [`/api/internal/teams`] as const;
};

export const getListAllTeamsApiInternalTeamsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAllTeamsApiInternalTeamsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>
  > = ({ signal }) =>
    listAllTeamsApiInternalTeamsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAllTeamsApiInternalTeamsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>
>;
export type ListAllTeamsApiInternalTeamsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListAllTeamsApiInternalTeamsGet<
  TData = Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
          TError,
          Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAllTeamsApiInternalTeamsGet<
  TData = Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
          TError,
          Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAllTeamsApiInternalTeamsGet<
  TData = Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List All Teams
 */

export function useListAllTeamsApiInternalTeamsGet<
  TData = Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllTeamsApiInternalTeamsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAllTeamsApiInternalTeamsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createTeamApiInternalTeamsPostResponse200 = {
  data: ImpersonatableTeam;
  status: 200;
};

export type createTeamApiInternalTeamsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createTeamApiInternalTeamsPostResponseSuccess =
  createTeamApiInternalTeamsPostResponse200 & {
    headers: Headers;
  };
export type createTeamApiInternalTeamsPostResponseError =
  createTeamApiInternalTeamsPostResponse422 & {
    headers: Headers;
  };

export type createTeamApiInternalTeamsPostResponse =
  | createTeamApiInternalTeamsPostResponseSuccess
  | createTeamApiInternalTeamsPostResponseError;

export const getCreateTeamApiInternalTeamsPostUrl = () => {
  return `/api/internal/teams`;
};

/**
 * Create a company team (Keycloak group), optionally with auto-join domains.
 *
 * Staff-only. Users signing in with an email on one of the team's
 * email_domains auto-join it on first sign-in (TRA-823), and existing
 * users with matching emails are added immediately (they already have
 * personal teams, so the first-sign-in hook won't fire for them). A domain
 * may be claimed by any number of teams (TRA-1432), so a second team on
 * an already-claimed domain is created like any other.
 *
 * The creating staff member becomes the team's single owner AND a member —
 * membership is required to later transfer ownership to a customer
 * (mutations aren't possible via impersonation). After transferring, the
 * new owner can remove the staff member from the team.
 * @summary Create Team
 */
export const createTeamApiInternalTeamsPost = async (
  createTeamRequest: CreateTeamRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createTeamApiInternalTeamsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createTeamApiInternalTeamsPostResponse>(
    getCreateTeamApiInternalTeamsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(createTeamRequest),
    },
  );
};

export const getCreateTeamApiInternalTeamsPostMutationKey = () =>
  ["createTeamApiInternalTeamsPost"] as const;

export const getCreateTeamApiInternalTeamsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeamApiInternalTeamsPost>>,
    TError,
    CreateTeamApiInternalTeamsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeamApiInternalTeamsPost>>,
  TError,
  CreateTeamApiInternalTeamsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateTeamApiInternalTeamsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeamApiInternalTeamsPost>>,
    CreateTeamApiInternalTeamsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createTeamApiInternalTeamsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeamApiInternalTeamsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeamApiInternalTeamsPost>>
>;
export type CreateTeamApiInternalTeamsPostMutationBody = CreateTeamRequest;
export type CreateTeamApiInternalTeamsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateTeamApiInternalTeamsPostMutationVariables = {
  data: CreateTeamRequest;
};

/**
 * @summary Create Team
 */
export const useCreateTeamApiInternalTeamsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTeamApiInternalTeamsPost>>,
      TError,
      CreateTeamApiInternalTeamsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTeamApiInternalTeamsPost>>,
  TError,
  CreateTeamApiInternalTeamsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateTeamApiInternalTeamsPostMutationOptions(options),
    queryClient,
  );
};
export type updateTeamNavApiInternalTeamsTeamIdNavPutResponse200 = {
  data: ImpersonatableTeam;
  status: 200;
};

export type updateTeamNavApiInternalTeamsTeamIdNavPutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateTeamNavApiInternalTeamsTeamIdNavPutResponseSuccess =
  updateTeamNavApiInternalTeamsTeamIdNavPutResponse200 & {
    headers: Headers;
  };
export type updateTeamNavApiInternalTeamsTeamIdNavPutResponseError =
  updateTeamNavApiInternalTeamsTeamIdNavPutResponse422 & {
    headers: Headers;
  };

export type updateTeamNavApiInternalTeamsTeamIdNavPutResponse =
  | updateTeamNavApiInternalTeamsTeamIdNavPutResponseSuccess
  | updateTeamNavApiInternalTeamsTeamIdNavPutResponseError;

export const getUpdateTeamNavApiInternalTeamsTeamIdNavPutUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/nav`;
};

/**
 * Set a team's sidebar visibility + landing page (TRA-927).
 *
 * Staff-only. Values are route paths validated against KNOWN_NAV_ROUTES —
 * unknown routes 400 rather than silently storing a route that no sidebar
 * entry will ever match.
 * @summary Update Team Nav
 */
export const updateTeamNavApiInternalTeamsTeamIdNavPut = async (
  teamId: string,
  updateTeamNavRequest: UpdateTeamNavRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateTeamNavApiInternalTeamsTeamIdNavPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateTeamNavApiInternalTeamsTeamIdNavPutResponse>(
    getUpdateTeamNavApiInternalTeamsTeamIdNavPutUrl(teamId),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(updateTeamNavRequest),
    },
  );
};

export const getUpdateTeamNavApiInternalTeamsTeamIdNavPutMutationKey = () =>
  ["updateTeamNavApiInternalTeamsTeamIdNavPut"] as const;

export const getUpdateTeamNavApiInternalTeamsTeamIdNavPutMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamNavApiInternalTeamsTeamIdNavPut>>,
    TError,
    UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeamNavApiInternalTeamsTeamIdNavPut>>,
  TError,
  UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateTeamNavApiInternalTeamsTeamIdNavPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeamNavApiInternalTeamsTeamIdNavPut>>,
    UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationVariables
  > = (props) => {
    const { teamId, data } = props ?? {};

    return updateTeamNavApiInternalTeamsTeamIdNavPut(
      teamId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTeamNavApiInternalTeamsTeamIdNavPut>>
  >;
export type UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationBody =
  UpdateTeamNavRequest;
export type UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationVariables = {
  teamId: string;
  data: UpdateTeamNavRequest;
};

/**
 * @summary Update Team Nav
 */
export const useUpdateTeamNavApiInternalTeamsTeamIdNavPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTeamNavApiInternalTeamsTeamIdNavPut>>,
      TError,
      UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTeamNavApiInternalTeamsTeamIdNavPut>>,
  TError,
  UpdateTeamNavApiInternalTeamsTeamIdNavPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateTeamNavApiInternalTeamsTeamIdNavPutMutationOptions(options),
    queryClient,
  );
};
export type updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse200 =
  {
    data: ImpersonatableTeam;
    status: 200;
  };

export type updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponseSuccess =
  updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse200 & {
    headers: Headers;
  };
export type updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponseError =
  updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse422 & {
    headers: Headers;
  };

export type updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse =

    | updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponseSuccess
    | updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponseError;

export const getUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutUrl =
  (teamId: string) => {
    return `/api/internal/teams/${teamId}/email-domains`;
  };

/**
 * Replace a team's auto-join email domains (TRA-823).
 *
 * Staff-only. The body is the whole set. A domain added here passes the
 * sign-up gate at once, new users on it join the team on first sign-in,
 * and existing users on it join now, as at team creation. A domain
 * removed here stops new sign-ups from it and lifts the removal guard
 * on the members who hold it; nobody is removed, so expelling a member
 * is a second step for the team's owner.
 *
 * The body also names the set the edit started from: a save built on a
 * stale read is a 409, never a silent overwrite. Every save backfills
 * the whole set, skipping current members, so a save whose backfill
 * failed partway is finished by sending it again.
 * @summary Update Team Email Domains
 */
export const updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut =
  async (
    teamId: string,
    updateTeamEmailDomainsRequest: UpdateTeamEmailDomainsRequest,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutResponse>(
      getUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutUrl(teamId),
      {
        ...options,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(updateTeamEmailDomainsRequest),
      },
    );
  };

export const getUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationKey =
  () =>
    ["updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut"] as const;

export const getUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut
        >
      >,
      TError,
      UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut
      >
    >,
    TError,
    UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut
        >
      >,
      UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationVariables
    > = (props) => {
      const { teamId, data } = props ?? {};

      return updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut(
        teamId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut
      >
    >
  >;
export type UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationBody =
  UpdateTeamEmailDomainsRequest;
export type UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationVariables =
  { teamId: string; data: UpdateTeamEmailDomainsRequest };

/**
 * @summary Update Team Email Domains
 */
export const useUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut
        >
      >,
      TError,
      UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPut
    >
  >,
  TError,
  UpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateTeamEmailDomainsApiInternalTeamsTeamIdEmailDomainsPutMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse200 =
  {
    data: TeamDeletePreview;
    status: 200;
  };

export type getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponseSuccess =
  getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse200 & {
    headers: Headers;
  };
export type getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponseError =
  getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse422 & {
    headers: Headers;
  };

export type getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse =
  | getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponseSuccess
  | getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponseError;

export const getGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetUrl =
  (teamId: string) => {
    return `/api/internal/teams/${teamId}/delete-preview`;
  };

/**
 * Staff: what deleting the team would remove, for the confirm dialog on
 * the team's configuration pages.
 * @summary Get Team Delete Preview
 */
export const getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet =
  async (
    teamId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse> => {
    return orvalFetch<getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetResponse>(
      getGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetUrl(teamId),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetQueryKey =
  (teamId: string) => {
    return [`/api/internal/teams/${teamId}/delete-preview`] as const;
  };

export const getGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetQueryKey(
        teamId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
        >
      >
    > = ({ signal }) =>
      getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet(teamId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
      >
    >
  >;
export type GetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Delete Preview
 */

export function useGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamDeletePreviewApiInternalTeamsTeamIdDeletePreviewGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteTeamApiInternalTeamsTeamIdDeleteResponse200 = {
  data: TeamDeleteResult;
  status: 200;
};

export type deleteTeamApiInternalTeamsTeamIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteTeamApiInternalTeamsTeamIdDeleteResponseSuccess =
  deleteTeamApiInternalTeamsTeamIdDeleteResponse200 & {
    headers: Headers;
  };
export type deleteTeamApiInternalTeamsTeamIdDeleteResponseError =
  deleteTeamApiInternalTeamsTeamIdDeleteResponse422 & {
    headers: Headers;
  };

export type deleteTeamApiInternalTeamsTeamIdDeleteResponse =
  | deleteTeamApiInternalTeamsTeamIdDeleteResponseSuccess
  | deleteTeamApiInternalTeamsTeamIdDeleteResponseError;

export const getDeleteTeamApiInternalTeamsTeamIdDeleteUrl = (
  teamId: string,
  params: DeleteTeamApiInternalTeamsTeamIdDeleteParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/internal/teams/${teamId}?${stringifiedParams}`
    : `/api/internal/teams/${teamId}`;
};

/**
 * Staff: delete a team and everything it owns (services/team_delete.py),
 * the same delete the owner has on Settings > Teams. Any team but a
 * protected one, so a test team can be reset without SQL or kubectl.
 * @summary Delete Team
 */
export const deleteTeamApiInternalTeamsTeamIdDelete = async (
  teamId: string,
  params: DeleteTeamApiInternalTeamsTeamIdDeleteParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<deleteTeamApiInternalTeamsTeamIdDeleteResponse> => {
  return orvalFetch<deleteTeamApiInternalTeamsTeamIdDeleteResponse>(
    getDeleteTeamApiInternalTeamsTeamIdDeleteUrl(teamId, params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteTeamApiInternalTeamsTeamIdDeleteMutationKey = () =>
  ["deleteTeamApiInternalTeamsTeamIdDelete"] as const;

export const getDeleteTeamApiInternalTeamsTeamIdDeleteMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeamApiInternalTeamsTeamIdDelete>>,
    TError,
    DeleteTeamApiInternalTeamsTeamIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeamApiInternalTeamsTeamIdDelete>>,
  TError,
  DeleteTeamApiInternalTeamsTeamIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteTeamApiInternalTeamsTeamIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeamApiInternalTeamsTeamIdDelete>>,
    DeleteTeamApiInternalTeamsTeamIdDeleteMutationVariables
  > = (props) => {
    const { teamId, params } = props ?? {};

    return deleteTeamApiInternalTeamsTeamIdDelete(
      teamId,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeamApiInternalTeamsTeamIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeamApiInternalTeamsTeamIdDelete>>
>;

export type DeleteTeamApiInternalTeamsTeamIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type DeleteTeamApiInternalTeamsTeamIdDeleteMutationVariables = {
  teamId: string;
  params: DeleteTeamApiInternalTeamsTeamIdDeleteParams;
};

/**
 * @summary Delete Team
 */
export const useDeleteTeamApiInternalTeamsTeamIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTeamApiInternalTeamsTeamIdDelete>>,
      TError,
      DeleteTeamApiInternalTeamsTeamIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeamApiInternalTeamsTeamIdDelete>>,
  TError,
  DeleteTeamApiInternalTeamsTeamIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteTeamApiInternalTeamsTeamIdDeleteMutationOptions(options),
    queryClient,
  );
};
export type dreamScanStatusApiInternalDreamScanGetResponse200 = {
  data: DreamScanStatusResponse;
  status: 200;
};

export type dreamScanStatusApiInternalDreamScanGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type dreamScanStatusApiInternalDreamScanGetResponseSuccess =
  dreamScanStatusApiInternalDreamScanGetResponse200 & {
    headers: Headers;
  };
export type dreamScanStatusApiInternalDreamScanGetResponseError =
  dreamScanStatusApiInternalDreamScanGetResponse422 & {
    headers: Headers;
  };

export type dreamScanStatusApiInternalDreamScanGetResponse =
  | dreamScanStatusApiInternalDreamScanGetResponseSuccess
  | dreamScanStatusApiInternalDreamScanGetResponseError;

export const getDreamScanStatusApiInternalDreamScanGetUrl = () => {
  return `/api/internal/dream-scan`;
};

/**
 * Staff: is a scan running now, and how did the last one go (TRA-942).
 *
 * Everything here comes from the k8s Job objects — deliberately no labels
 * query: a flags-written count would have to span every team's rows
 * (REVIEW.md: every query filters on team_id), and the flags themselves
 * are already visible in /review, with per-run detail in the Slack
 * notification.
 * @summary Dream Scan Status
 */
export const dreamScanStatusApiInternalDreamScanGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<dreamScanStatusApiInternalDreamScanGetResponse> => {
  return orvalFetch<dreamScanStatusApiInternalDreamScanGetResponse>(
    getDreamScanStatusApiInternalDreamScanGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getDreamScanStatusApiInternalDreamScanGetQueryKey = () => {
  return [`/api/internal/dream-scan`] as const;
};

export const getDreamScanStatusApiInternalDreamScanGetQueryOptions = <
  TData = Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDreamScanStatusApiInternalDreamScanGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>
  > = ({ signal }) =>
    dreamScanStatusApiInternalDreamScanGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DreamScanStatusApiInternalDreamScanGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>
>;
export type DreamScanStatusApiInternalDreamScanGetQueryError =
  ErrorType<HTTPValidationError>;

export function useDreamScanStatusApiInternalDreamScanGet<
  TData = Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
          TError,
          Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDreamScanStatusApiInternalDreamScanGet<
  TData = Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
          TError,
          Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDreamScanStatusApiInternalDreamScanGet<
  TData = Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Dream Scan Status
 */

export function useDreamScanStatusApiInternalDreamScanGet<
  TData = Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dreamScanStatusApiInternalDreamScanGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getDreamScanStatusApiInternalDreamScanGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type runDreamScanApiInternalDreamScanRunPostResponse200 = {
  data: JobStartedResponse;
  status: 200;
};

export type runDreamScanApiInternalDreamScanRunPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type runDreamScanApiInternalDreamScanRunPostResponseSuccess =
  runDreamScanApiInternalDreamScanRunPostResponse200 & {
    headers: Headers;
  };
export type runDreamScanApiInternalDreamScanRunPostResponseError =
  runDreamScanApiInternalDreamScanRunPostResponse422 & {
    headers: Headers;
  };

export type runDreamScanApiInternalDreamScanRunPostResponse =
  | runDreamScanApiInternalDreamScanRunPostResponseSuccess
  | runDreamScanApiInternalDreamScanRunPostResponseError;

export const getRunDreamScanApiInternalDreamScanRunPostUrl = () => {
  return `/api/internal/dream-scan/run`;
};

/**
 * Staff: start a dream scan over every team now (the chain scans one
 * team at its threshold; this is the all-teams start).
 *
 * The scan only ever ADDS flags — it has no delete or update path, and
 * every conversation with any existing label is skipped — so the worst
 * case of a manual run is judge-call cost, never data loss. Refused with
 * 409 while a scan Job is active: two concurrent scans wouldn't corrupt
 * anything (uq_labels_team_trace holds) but would double-spend on judge
 * calls for the same trajectories.
 * @summary Run Dream Scan
 */
export const runDreamScanApiInternalDreamScanRunPost = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<runDreamScanApiInternalDreamScanRunPostResponse> => {
  return orvalFetch<runDreamScanApiInternalDreamScanRunPostResponse>(
    getRunDreamScanApiInternalDreamScanRunPostUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunDreamScanApiInternalDreamScanRunPostMutationKey = () =>
  ["runDreamScanApiInternalDreamScanRunPost"] as const;

export const getRunDreamScanApiInternalDreamScanRunPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runDreamScanApiInternalDreamScanRunPost>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runDreamScanApiInternalDreamScanRunPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getRunDreamScanApiInternalDreamScanRunPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runDreamScanApiInternalDreamScanRunPost>>,
    void
  > = () => {
    return runDreamScanApiInternalDreamScanRunPost(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunDreamScanApiInternalDreamScanRunPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof runDreamScanApiInternalDreamScanRunPost>>
>;

export type RunDreamScanApiInternalDreamScanRunPostMutationError =
  ErrorType<HTTPValidationError>;

/**
 * @summary Run Dream Scan
 */
export const useRunDreamScanApiInternalDreamScanRunPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runDreamScanApiInternalDreamScanRunPost>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runDreamScanApiInternalDreamScanRunPost>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getRunDreamScanApiInternalDreamScanRunPostMutationOptions(options),
    queryClient,
  );
};
export type listTeamJobsApiInternalTeamsTeamIdJobsGetResponse200 = {
  data: TeamJobListResponse;
  status: 200;
};

export type listTeamJobsApiInternalTeamsTeamIdJobsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTeamJobsApiInternalTeamsTeamIdJobsGetResponseSuccess =
  listTeamJobsApiInternalTeamsTeamIdJobsGetResponse200 & {
    headers: Headers;
  };
export type listTeamJobsApiInternalTeamsTeamIdJobsGetResponseError =
  listTeamJobsApiInternalTeamsTeamIdJobsGetResponse422 & {
    headers: Headers;
  };

export type listTeamJobsApiInternalTeamsTeamIdJobsGetResponse =
  | listTeamJobsApiInternalTeamsTeamIdJobsGetResponseSuccess
  | listTeamJobsApiInternalTeamsTeamIdJobsGetResponseError;

export const getListTeamJobsApiInternalTeamsTeamIdJobsGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/jobs`;
};

/**
 * Staff: the jobs that can be started for a team, each with the team's
 * active run and its last finished one.
 * @summary List Team Jobs
 */
export const listTeamJobsApiInternalTeamsTeamIdJobsGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTeamJobsApiInternalTeamsTeamIdJobsGetResponse> => {
  return orvalFetch<listTeamJobsApiInternalTeamsTeamIdJobsGetResponse>(
    getListTeamJobsApiInternalTeamsTeamIdJobsGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTeamJobsApiInternalTeamsTeamIdJobsGetQueryKey = (
  teamId: string,
) => {
  return [`/api/internal/teams/${teamId}/jobs`] as const;
};

export const getListTeamJobsApiInternalTeamsTeamIdJobsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTeamJobsApiInternalTeamsTeamIdJobsGetQueryKey(teamId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>
  > = ({ signal }) =>
    listTeamJobsApiInternalTeamsTeamIdJobsGet(teamId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: teamId !== null && teamId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTeamJobsApiInternalTeamsTeamIdJobsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>
>;
export type ListTeamJobsApiInternalTeamsTeamIdJobsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTeamJobsApiInternalTeamsTeamIdJobsGet<
  TData = Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamJobsApiInternalTeamsTeamIdJobsGet<
  TData = Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamJobsApiInternalTeamsTeamIdJobsGet<
  TData = Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Team Jobs
 */

export function useListTeamJobsApiInternalTeamsTeamIdJobsGet<
  TData = Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamJobsApiInternalTeamsTeamIdJobsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTeamJobsApiInternalTeamsTeamIdJobsGetQueryOptions(
    teamId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse200 = {
  data: JobStartedResponse;
  status: 200;
};

export type runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponseSuccess =
  runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse200 & {
    headers: Headers;
  };
export type runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponseError =
  runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse422 & {
    headers: Headers;
  };

export type runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse =
  | runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponseSuccess
  | runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponseError;

export const getRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostUrl = (
  teamId: string,
  jobSlug: string,
) => {
  return `/api/internal/teams/${teamId}/jobs/${jobSlug}/run`;
};

/**
 * Staff: start one run of a job for a team now, outside its schedule.
 *
 * The run is the CronJob's own, narrowed to the team, so it does what
 * the scheduled run does and nothing else, plus the job's option when
 * the start chose it (`team_jobs.StartOption`). Refused with 409 when
 * the job would skip the team or fail on it: that Job would finish
 * having done nothing, or page.
 * @summary Run Team Job
 */
export const runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost = async (
  teamId: string,
  jobSlug: string,
  teamJobRunRequestNull?: TeamJobRunRequest | null,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostResponse>(
    getRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostUrl(teamId, jobSlug),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(teamJobRunRequestNull),
    },
  );
};

export const getRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationKey =
  () => ["runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost"] as const;

export const getRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost>
      >,
      TError,
      RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost>
    >,
    TError,
    RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost>
      >,
      RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationVariables
    > = (props) => {
      const { teamId, jobSlug, data } = props ?? {};

      return runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost(
        teamId,
        jobSlug,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost>
    >
  >;
export type RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationBody =
  | TeamJobRunRequest
  | null
  | undefined;
export type RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationError =
  ErrorType<HTTPValidationError>;
export type RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationVariables =
  { teamId: string; jobSlug: string; data?: TeamJobRunRequest | null };

/**
 * @summary Run Team Job
 */
export const useRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost>
      >,
      TError,
      RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof runTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPost>
  >,
  TError,
  RunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRunTeamJobApiInternalTeamsTeamIdJobsJobSlugRunPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse200 =
  {
    data: TeamJobLogResponse;
    status: 200;
  };

export type readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponseSuccess =
  readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse200 & {
    headers: Headers;
  };
export type readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponseError =
  readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse422 & {
    headers: Headers;
  };

export type readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse =

    | readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponseSuccess
    | readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponseError;

export const getReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetUrl =
  (teamId: string, jobSlug: string, jobName: string) => {
    return `/api/internal/teams/${teamId}/jobs/${jobSlug}/runs/${jobName}/log`;
  };

/**
 * Staff: the newest lines of one of the team's runs' log (`_team_run`).
 * A scheduled run of a job that works on every team (the review scan,
 * the benchmark inventory) counts as the team's run, and its log names
 * every team it worked on. The page is staff's.
 * @summary Read Team Job Log
 */
export const readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet =
  async (
    teamId: string,
    jobSlug: string,
    jobName: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse> => {
    return orvalFetch<readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetResponse>(
      getReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetUrl(
        teamId,
        jobSlug,
        jobName,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetQueryKey =
  (teamId: string, jobSlug: string, jobName: string) => {
    return [
      `/api/internal/teams/${teamId}/jobs/${jobSlug}/runs/${jobName}/log`,
    ] as const;
  };

export const getReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    jobSlug: string,
    jobName: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetQueryKey(
        teamId,
        jobSlug,
        jobName,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
        >
      >
    > = ({ signal }) =>
      readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet(
        teamId,
        jobSlug,
        jobName,
        { signal, ...requestOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled:
        teamId !== null &&
        teamId !== undefined &&
        jobSlug !== null &&
        jobSlug !== undefined &&
        jobName !== null &&
        jobName !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
      >
    >
  >;
export type ReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetQueryError =
  ErrorType<HTTPValidationError>;

export function useReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet<
  TData = Awaited<
    ReturnType<
      typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  jobSlug: string,
  jobName: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet<
  TData = Awaited<
    ReturnType<
      typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  jobSlug: string,
  jobName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet<
  TData = Awaited<
    ReturnType<
      typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  jobSlug: string,
  jobName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read Team Job Log
 */

export function useReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet<
  TData = Awaited<
    ReturnType<
      typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  jobSlug: string,
  jobName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof readTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getReadTeamJobLogApiInternalTeamsTeamIdJobsJobSlugRunsJobNameLogGetQueryOptions(
      teamId,
      jobSlug,
      jobName,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse200 =
  {
    data: JobStoppedResponse;
    status: 200;
  };

export type stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponseSuccess =
  stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse200 & {
    headers: Headers;
  };
export type stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponseError =
  stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse422 & {
    headers: Headers;
  };

export type stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse =

    | stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponseSuccess
    | stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponseError;

export const getStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostUrl =
  (teamId: string, jobSlug: string, jobName: string) => {
    return `/api/internal/teams/${teamId}/jobs/${jobSlug}/runs/${jobName}/stop`;
  };

/**
 * Staff: stop one of the team's active runs (`_team_run`) by deleting
 * its Job, and with it its pod and the pod's log. The delete is
 * foreground, so the Job stays on the list as active, and holds the run
 * button, until its pod has ended. A killed pod sends no finished event,
 * so the chain starts no next stage (services/pipeline_chain.py). 409 for
 * a run the stop refuses (`team_jobs.stop_refusal`).
 * @summary Stop Team Job
 */
export const stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost =
  async (
    teamId: string,
    jobSlug: string,
    jobName: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse> => {
    return orvalFetch<stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostResponse>(
      getStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostUrl(
        teamId,
        jobSlug,
        jobName,
      ),
      {
        ...options,
        method: "POST",
      },
    );
  };

export const getStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationKey =
  () =>
    [
      "stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost",
    ] as const;

export const getStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost
        >
      >,
      TError,
      StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost
      >
    >,
    TError,
    StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost
        >
      >,
      StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationVariables
    > = (props) => {
      const { teamId, jobSlug, jobName } = props ?? {};

      return stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost(
        teamId,
        jobSlug,
        jobName,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost
      >
    >
  >;

export type StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationError =
  ErrorType<HTTPValidationError>;
export type StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationVariables =
  { teamId: string; jobSlug: string; jobName: string };

/**
 * @summary Stop Team Job
 */
export const useStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost
          >
        >,
        TError,
        StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof stopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPost
      >
    >,
    TError,
    StopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getStopTeamJobApiInternalTeamsTeamIdJobsJobSlugRunsJobNameStopPostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse200 =
  {
    data: ConnectionAdminListResponse;
    status: 200;
  };

export type listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponseSuccess =
  listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse200 & {
    headers: Headers;
  };
export type listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponseError =
  listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse422 & {
    headers: Headers;
  };

export type listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse =
  | listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponseSuccess
  | listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponseError;

export const getListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/connections`;
};

/**
 * Staff: the source connections assigned to a team (TRA-922).
 * @summary List Team Connections
 */
export const listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse> => {
  return orvalFetch<listTeamConnectionsApiInternalTeamsTeamIdConnectionsGetResponse>(
    getListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetQueryKey =
  (teamId: string) => {
    return [`/api/internal/teams/${teamId}/connections`] as const;
  };

export const getListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetQueryKey(
        teamId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
        >
      >
    > = ({ signal }) =>
      listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet(teamId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet>
    >
  >;
export type ListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTeamConnectionsApiInternalTeamsTeamIdConnectionsGet<
  TData = Awaited<
    ReturnType<typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamConnectionsApiInternalTeamsTeamIdConnectionsGet<
  TData = Awaited<
    ReturnType<typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamConnectionsApiInternalTeamsTeamIdConnectionsGet<
  TData = Awaited<
    ReturnType<typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Team Connections
 */

export function useListTeamConnectionsApiInternalTeamsTeamIdConnectionsGet<
  TData = Awaited<
    ReturnType<typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTeamConnectionsApiInternalTeamsTeamIdConnectionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTeamConnectionsApiInternalTeamsTeamIdConnectionsGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse200 =
  {
    data: ConnectionAdminItem;
    status: 200;
  };

export type createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponseSuccess =
  createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse200 & {
    headers: Headers;
  };
export type createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponseError =
  createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse422 & {
    headers: Headers;
  };

export type createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse =
  | createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponseSuccess
  | createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponseError;

export const getCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/connections`;
};

/**
 * Staff: assign a source connection to a team (TRA-922, TRA-1108).
 *
 * Like alpha gating, assignment is an ops action — customers only ever
 * see the connections already on their team. `kind` picks the shape: an
 * S3 key pair, a customer role TrainLoop assumes (no secret stored; the
 * response carries the External ID the customer's trust policy must
 * require), or the team's installation of the TrainLoop GitHub App for
 * eval PRs and repo reads (one per team).
 * @summary Create Team Connection
 */
export const createTeamConnectionApiInternalTeamsTeamIdConnectionsPost = async (
  teamId: string,
  createS3ConnectionRequestCreateS3RoleConnectionRequestCreateGithubConnectionRequest:
    | CreateS3ConnectionRequest
    | CreateS3RoleConnectionRequest
    | CreateGithubConnectionRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createTeamConnectionApiInternalTeamsTeamIdConnectionsPostResponse>(
    getCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostUrl(teamId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(
        createS3ConnectionRequestCreateS3RoleConnectionRequestCreateGithubConnectionRequest,
      ),
    },
  );
};

export const getCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationKey =
  () => ["createTeamConnectionApiInternalTeamsTeamIdConnectionsPost"] as const;

export const getCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTeamConnectionApiInternalTeamsTeamIdConnectionsPost
        >
      >,
      TError,
      CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createTeamConnectionApiInternalTeamsTeamIdConnectionsPost
      >
    >,
    TError,
    CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createTeamConnectionApiInternalTeamsTeamIdConnectionsPost
        >
      >,
      CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationVariables
    > = (props) => {
      const { teamId, data } = props ?? {};

      return createTeamConnectionApiInternalTeamsTeamIdConnectionsPost(
        teamId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createTeamConnectionApiInternalTeamsTeamIdConnectionsPost
      >
    >
  >;
export type CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationBody =

    | CreateS3ConnectionRequest
    | CreateS3RoleConnectionRequest
    | CreateGithubConnectionRequest;
export type CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationVariables =
  {
    teamId: string;
    data:
      | CreateS3ConnectionRequest
      | CreateS3RoleConnectionRequest
      | CreateGithubConnectionRequest;
  };

/**
 * @summary Create Team Connection
 */
export const useCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTeamConnectionApiInternalTeamsTeamIdConnectionsPost
        >
      >,
      TError,
      CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof createTeamConnectionApiInternalTeamsTeamIdConnectionsPost>
  >,
  TError,
  CreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateTeamConnectionApiInternalTeamsTeamIdConnectionsPostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse200 =
  {
    data: ConnectionAdminItem;
    status: 200;
  };

export type deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponseSuccess =
  deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse200 & {
    headers: Headers;
  };
export type deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponseError =
  deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse422 & {
    headers: Headers;
  };

export type deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse =

    | deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponseSuccess
    | deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponseError;

export const getDeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteUrl =
  (connectionId: string) => {
    return `/api/internal/connections/${connectionId}`;
  };

/**
 * Staff: remove a connection. 409 while ingestions still reference it —
 * the FK is deliberately RESTRICT so history keeps its provenance.
 * @summary Delete Team Connection
 */
export const deleteTeamConnectionApiInternalConnectionsConnectionIdDelete =
  async (
    connectionId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse> => {
    return orvalFetch<deleteTeamConnectionApiInternalConnectionsConnectionIdDeleteResponse>(
      getDeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteUrl(
        connectionId,
      ),
      {
        ...options,
        method: "DELETE",
      },
    );
  };

export const getDeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationKey =
  () =>
    ["deleteTeamConnectionApiInternalConnectionsConnectionIdDelete"] as const;

export const getDeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTeamConnectionApiInternalConnectionsConnectionIdDelete
        >
      >,
      TError,
      DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTeamConnectionApiInternalConnectionsConnectionIdDelete
      >
    >,
    TError,
    DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTeamConnectionApiInternalConnectionsConnectionIdDelete
        >
      >,
      DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationVariables
    > = (props) => {
      const { connectionId } = props ?? {};

      return deleteTeamConnectionApiInternalConnectionsConnectionIdDelete(
        connectionId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTeamConnectionApiInternalConnectionsConnectionIdDelete
      >
    >
  >;

export type DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationVariables =
  { connectionId: string };

/**
 * @summary Delete Team Connection
 */
export const useDeleteTeamConnectionApiInternalConnectionsConnectionIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTeamConnectionApiInternalConnectionsConnectionIdDelete
        >
      >,
      TError,
      DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteTeamConnectionApiInternalConnectionsConnectionIdDelete
    >
  >,
  TError,
  DeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteTeamConnectionApiInternalConnectionsConnectionIdDeleteMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getPlatformGithubAppApiInternalGithubAppGetResponse200 = {
  data: PlatformGithubAppView;
  status: 200;
};

export type getPlatformGithubAppApiInternalGithubAppGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getPlatformGithubAppApiInternalGithubAppGetResponseSuccess =
  getPlatformGithubAppApiInternalGithubAppGetResponse200 & {
    headers: Headers;
  };
export type getPlatformGithubAppApiInternalGithubAppGetResponseError =
  getPlatformGithubAppApiInternalGithubAppGetResponse422 & {
    headers: Headers;
  };

export type getPlatformGithubAppApiInternalGithubAppGetResponse =
  | getPlatformGithubAppApiInternalGithubAppGetResponseSuccess
  | getPlatformGithubAppApiInternalGithubAppGetResponseError;

export const getGetPlatformGithubAppApiInternalGithubAppGetUrl = () => {
  return `/api/internal/github-app`;
};

/**
 * Staff: the GitHub App this deployment signs with. 404 until one is
 * recorded, which is the state every mint and the webhook refuse in.
 * @summary Get Platform Github App
 */
export const getPlatformGithubAppApiInternalGithubAppGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getPlatformGithubAppApiInternalGithubAppGetResponse> => {
  return orvalFetch<getPlatformGithubAppApiInternalGithubAppGetResponse>(
    getGetPlatformGithubAppApiInternalGithubAppGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlatformGithubAppApiInternalGithubAppGetQueryKey = () => {
  return [`/api/internal/github-app`] as const;
};

export const getGetPlatformGithubAppApiInternalGithubAppGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformGithubAppApiInternalGithubAppGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>
  > = ({ signal }) =>
    getPlatformGithubAppApiInternalGithubAppGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformGithubAppApiInternalGithubAppGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>
  >;
export type GetPlatformGithubAppApiInternalGithubAppGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetPlatformGithubAppApiInternalGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlatformGithubAppApiInternalGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlatformGithubAppApiInternalGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Platform Github App
 */

export function useGetPlatformGithubAppApiInternalGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformGithubAppApiInternalGithubAppGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetPlatformGithubAppApiInternalGithubAppGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type savePlatformGithubAppApiInternalGithubAppPutResponse200 = {
  data: PlatformGithubAppView;
  status: 200;
};

export type savePlatformGithubAppApiInternalGithubAppPutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type savePlatformGithubAppApiInternalGithubAppPutResponseSuccess =
  savePlatformGithubAppApiInternalGithubAppPutResponse200 & {
    headers: Headers;
  };
export type savePlatformGithubAppApiInternalGithubAppPutResponseError =
  savePlatformGithubAppApiInternalGithubAppPutResponse422 & {
    headers: Headers;
  };

export type savePlatformGithubAppApiInternalGithubAppPutResponse =
  | savePlatformGithubAppApiInternalGithubAppPutResponseSuccess
  | savePlatformGithubAppApiInternalGithubAppPutResponseError;

export const getSavePlatformGithubAppApiInternalGithubAppPutUrl = () => {
  return `/api/internal/github-app`;
};

/**
 * Staff: record, or replace, the GitHub App this deployment signs
 * with (docs/github-app-runbook.md). The webhook secret is encrypted
 * before the row exists and never returned; the id and key version are
 * proven against GitHub first, so the row never names an App that
 * cannot mint.
 * @summary Save Platform Github App
 */
export const savePlatformGithubAppApiInternalGithubAppPut = async (
  savePlatformGithubAppRequest: SavePlatformGithubAppRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<savePlatformGithubAppApiInternalGithubAppPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<savePlatformGithubAppApiInternalGithubAppPutResponse>(
    getSavePlatformGithubAppApiInternalGithubAppPutUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(savePlatformGithubAppRequest),
    },
  );
};

export const getSavePlatformGithubAppApiInternalGithubAppPutMutationKey = () =>
  ["savePlatformGithubAppApiInternalGithubAppPut"] as const;

export const getSavePlatformGithubAppApiInternalGithubAppPutMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePlatformGithubAppApiInternalGithubAppPut>>,
    TError,
    SavePlatformGithubAppApiInternalGithubAppPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savePlatformGithubAppApiInternalGithubAppPut>>,
  TError,
  SavePlatformGithubAppApiInternalGithubAppPutMutationVariables,
  TContext
> => {
  const mutationKey =
    getSavePlatformGithubAppApiInternalGithubAppPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savePlatformGithubAppApiInternalGithubAppPut>>,
    SavePlatformGithubAppApiInternalGithubAppPutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return savePlatformGithubAppApiInternalGithubAppPut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavePlatformGithubAppApiInternalGithubAppPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof savePlatformGithubAppApiInternalGithubAppPut>>
  >;
export type SavePlatformGithubAppApiInternalGithubAppPutMutationBody =
  SavePlatformGithubAppRequest;
export type SavePlatformGithubAppApiInternalGithubAppPutMutationError =
  ErrorType<HTTPValidationError>;
export type SavePlatformGithubAppApiInternalGithubAppPutMutationVariables = {
  data: SavePlatformGithubAppRequest;
};

/**
 * @summary Save Platform Github App
 */
export const useSavePlatformGithubAppApiInternalGithubAppPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savePlatformGithubAppApiInternalGithubAppPut>>,
      TError,
      SavePlatformGithubAppApiInternalGithubAppPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savePlatformGithubAppApiInternalGithubAppPut>>,
  TError,
  SavePlatformGithubAppApiInternalGithubAppPutMutationVariables,
  TContext
> => {
  return useMutation(
    getSavePlatformGithubAppApiInternalGithubAppPutMutationOptions(options),
    queryClient,
  );
};
export type listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse200 =
  {
    data: PlatformGithubAppInstallationsResponse;
    status: 200;
  };

export type listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponseSuccess =
  listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse200 & {
    headers: Headers;
  };
export type listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponseError =
  listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse422 & {
    headers: Headers;
  };

export type listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse =

    | listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponseSuccess
    | listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponseError;

export const getListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetUrl =
  () => {
    return `/api/internal/github-app/installations`;
  };

/**
 * Staff: every installation of this deployment's App on cloud GitHub,
 * newest first (TRA-1577). The Add benchmark dialog links one to a team
 * through the same create as the Connections page, which proves the
 * installation before it writes the row.
 * @summary List Platform Github App Installations
 */
export const listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet =
  async (
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse> => {
    return orvalFetch<listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetResponse>(
      getListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetUrl(),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetQueryKey =
  () => {
    return [`/api/internal/github-app/installations`] as const;
  };

export const getListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
        >
      >
    > = ({ signal }) =>
      listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet({
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
      >
    >
  >;
export type ListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Platform Github App Installations
 */

export function useListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet<
  TData = Awaited<
    ReturnType<
      typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListPlatformGithubAppInstallationsApiInternalGithubAppInstallationsGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listTrainingPresetsApiInternalTrainingPresetsGetResponse200 = {
  data: TrainingPresetsResponse;
  status: 200;
};

export type listTrainingPresetsApiInternalTrainingPresetsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTrainingPresetsApiInternalTrainingPresetsGetResponseSuccess =
  listTrainingPresetsApiInternalTrainingPresetsGetResponse200 & {
    headers: Headers;
  };
export type listTrainingPresetsApiInternalTrainingPresetsGetResponseError =
  listTrainingPresetsApiInternalTrainingPresetsGetResponse422 & {
    headers: Headers;
  };

export type listTrainingPresetsApiInternalTrainingPresetsGetResponse =
  | listTrainingPresetsApiInternalTrainingPresetsGetResponseSuccess
  | listTrainingPresetsApiInternalTrainingPresetsGetResponseError;

export const getListTrainingPresetsApiInternalTrainingPresetsGetUrl = () => {
  return `/api/internal/training-presets`;
};

/**
 * Staff: the presets the chain's training may run on this stack, for
 * the training fields of the Evals config page and the Add benchmark
 * dialog. The same for every team: the stack's trainer decides them.
 * The default is the presets file's chain default, not the stack's
 * launch-dialog default (`training_grpo.chain_default_preset`).
 * @summary List Training Presets
 */
export const listTrainingPresetsApiInternalTrainingPresetsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTrainingPresetsApiInternalTrainingPresetsGetResponse> => {
  return orvalFetch<listTrainingPresetsApiInternalTrainingPresetsGetResponse>(
    getListTrainingPresetsApiInternalTrainingPresetsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTrainingPresetsApiInternalTrainingPresetsGetQueryKey =
  () => {
    return [`/api/internal/training-presets`] as const;
  };

export const getListTrainingPresetsApiInternalTrainingPresetsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTrainingPresetsApiInternalTrainingPresetsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>>
  > = ({ signal }) =>
    listTrainingPresetsApiInternalTrainingPresetsGet({
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTrainingPresetsApiInternalTrainingPresetsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>>
  >;
export type ListTrainingPresetsApiInternalTrainingPresetsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTrainingPresetsApiInternalTrainingPresetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingPresetsApiInternalTrainingPresetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTrainingPresetsApiInternalTrainingPresetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Training Presets
 */

export function useListTrainingPresetsApiInternalTrainingPresetsGet<
  TData = Awaited<
    ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTrainingPresetsApiInternalTrainingPresetsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTrainingPresetsApiInternalTrainingPresetsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse200 =
  {
    data: TeamEvalsConfigResponse;
    status: 200;
  };

export type getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponseSuccess =
  getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse200 & {
    headers: Headers;
  };
export type getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponseError =
  getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse422 & {
    headers: Headers;
  };

export type getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse =
  | getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponseSuccess
  | getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponseError;

export const getGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/evals-config`;
};

/**
 * Staff: a team's customer config row, with the model and secret names
 * the night will find. `config` is null for a team that has none yet.
 * @summary Get Team Evals Config
 */
export const getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse> => {
  return orvalFetch<getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetResponse>(
    getGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetQueryKey =
  (teamId: string) => {
    return [`/api/internal/teams/${teamId}/evals-config`] as const;
  };

export const getGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetQueryKey(teamId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
        >
      >
    > = ({ signal }) =>
      getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet(teamId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet>
    >
  >;
export type GetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet<
  TData = Awaited<
    ReturnType<typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet<
  TData = Awaited<
    ReturnType<typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet<
  TData = Awaited<
    ReturnType<typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Evals Config
 */

export function useGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet<
  TData = Awaited<
    ReturnType<typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse200 =
  {
    data: TeamEvalsConfigResponse;
    status: 200;
  };

export type updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponseSuccess =
  updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse200 & {
    headers: Headers;
  };
export type updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponseError =
  updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse422 & {
    headers: Headers;
  };

export type updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse =
  | updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponseSuccess
  | updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponseError;

export const getUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/evals-config`;
};

/**
 * Staff: write the team's customer config row, creating it when the
 * team has none.
 *
 * One body for both, because it carries every column staff own: the
 * difference between onboarding a customer and editing one is whether a
 * row was there, not what the form sends. 400 for a team with no gateway
 * credentials, since the row is keyed by that slug. The eval PR layout
 * is optional as a whole, and needs a GitHub benchmark on the scored
 * group; the benchmark index file is optional on its own, and needs the
 * layout. A repository the team's installation cannot reach is a 400 the
 * first time a benchmark names it; an S3 benchmark must read through one
 * of this team's own connections. Arming scoring on a group no benchmark
 * on the row fills is a 400. Enabling a team that is missing a
 * default model, a scored benchmark or a GitHub connection is allowed;
 * the night skips it with that reason, and the page shows the same facts
 * beside the switch. A save made from a stale read is a 409
 * (`_refuse_stale_save`).
 * @summary Update Team Evals Config
 */
export const updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut = async (
  teamId: string,
  saveTeamEvalsConfigRequest: SaveTeamEvalsConfigRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutResponse>(
    getUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutUrl(teamId),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(saveTeamEvalsConfigRequest),
    },
  );
};

export const getUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationKey =
  () => ["updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut"] as const;

export const getUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut
        >
      >,
      TError,
      UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut
      >
    >,
    TError,
    UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut
        >
      >,
      UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationVariables
    > = (props) => {
      const { teamId, data } = props ?? {};

      return updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut(
        teamId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut
      >
    >
  >;
export type UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationBody =
  SaveTeamEvalsConfigRequest;
export type UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationVariables =
  { teamId: string; data: SaveTeamEvalsConfigRequest };

/**
 * @summary Update Team Evals Config
 */
export const useUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut
        >
      >,
      TError,
      UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPut>
  >,
  TError,
  UpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateTeamEvalsConfigApiInternalTeamsTeamIdEvalsConfigPutMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse200 = {
  data: GithubAppStatus;
  status: 200;
};

export type getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponseSuccess =
  getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse200 & {
    headers: Headers;
  };
export type getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponseError =
  getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse422 & {
    headers: Headers;
  };

export type getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse =
  | getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponseSuccess
  | getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponseError;

export const getGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/github-app`;
};

/**
 * Staff: the team's GitHub App installation as the customer sees it
 * on Settings > GitHub App, with the repositories it covers. The
 * Evals config page picks the repository the night checks out from
 * that list, so what staff can choose is what the installation can
 * read. Same read, same statuses, never an error for a GitHub failure.
 * @summary Get Team Github App
 */
export const getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse> => {
  return orvalFetch<getTeamGithubAppApiInternalTeamsTeamIdGithubAppGetResponse>(
    getGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetQueryKey = (
  teamId: string,
) => {
  return [`/api/internal/teams/${teamId}/github-app`] as const;
};

export const getGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetQueryKey(teamId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
      >
    > = ({ signal }) =>
      getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet(teamId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
    >
  >;
export type GetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Github App
 */

export function useGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGet<
  TData = Awaited<
    ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamGithubAppApiInternalTeamsTeamIdGithubAppGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamGithubAppApiInternalTeamsTeamIdGithubAppGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse200 = {
  data: WorldJudgeResponse;
  status: 200;
};

export type getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponseSuccess =
  getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse200 & {
    headers: Headers;
  };
export type getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponseError =
  getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse422 & {
    headers: Headers;
  };

export type getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse =
  | getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponseSuccess
  | getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponseError;

export const getGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetUrl = (
  teamId: string,
  params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/internal/teams/${teamId}/world-judge?${stringifiedParams}`
    : `/api/internal/teams/${teamId}/world-judge`;
};

/**
 * Staff: the judge the trainloop-env world at `repo`@`ref` names in
 * its `world.json`, read through the team's GitHub App installation for
 * the Add benchmark dialog, which shows it read-only and refuses Add when
 * `model` is null. The installation token never leaves the api.
 *
 * A missing installation, an unknown branch, or a missing or malformed
 * `world.json` is a 400 naming it; a GitHub failure maps as the other
 * installation reads do (400, 502, 503), never a 500.
 * @summary Get Team World Judge
 */
export const getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet = async (
  teamId: string,
  params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse> => {
  return orvalFetch<getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetResponse>(
    getGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetUrl(teamId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetQueryKey = (
  teamId: string,
  params?: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
) => {
  return [
    `/api/internal/teams/${teamId}/world-judge`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetQueryKey(
        teamId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
      >
    > = ({ signal }) =>
      getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet(teamId, params, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
    >
  >;
export type GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet<
  TData = Awaited<
    ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet<
  TData = Awaited<
    ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet<
  TData = Awaited<
    ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team World Judge
 */

export function useGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet<
  TData = Awaited<
    ReturnType<typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  params: GetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamWorldJudgeApiInternalTeamsTeamIdWorldJudgeGetQueryOptions(
      teamId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listRegisteredPipelinesApiInternalPipelinesGetResponse200 = {
  data: PipelineRegistryResponse;
  status: 200;
};

export type listRegisteredPipelinesApiInternalPipelinesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listRegisteredPipelinesApiInternalPipelinesGetResponseSuccess =
  listRegisteredPipelinesApiInternalPipelinesGetResponse200 & {
    headers: Headers;
  };
export type listRegisteredPipelinesApiInternalPipelinesGetResponseError =
  listRegisteredPipelinesApiInternalPipelinesGetResponse422 & {
    headers: Headers;
  };

export type listRegisteredPipelinesApiInternalPipelinesGetResponse =
  | listRegisteredPipelinesApiInternalPipelinesGetResponseSuccess
  | listRegisteredPipelinesApiInternalPipelinesGetResponseError;

export const getListRegisteredPipelinesApiInternalPipelinesGetUrl = () => {
  return `/api/internal/pipelines`;
};

/**
 * Staff: every pipeline in the registry, the names a grant may carry.
 * @summary List Registered Pipelines
 */
export const listRegisteredPipelinesApiInternalPipelinesGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listRegisteredPipelinesApiInternalPipelinesGetResponse> => {
  return orvalFetch<listRegisteredPipelinesApiInternalPipelinesGetResponse>(
    getListRegisteredPipelinesApiInternalPipelinesGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListRegisteredPipelinesApiInternalPipelinesGetQueryKey = () => {
  return [`/api/internal/pipelines`] as const;
};

export const getListRegisteredPipelinesApiInternalPipelinesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRegisteredPipelinesApiInternalPipelinesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>>
  > = ({ signal }) =>
    listRegisteredPipelinesApiInternalPipelinesGet({
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRegisteredPipelinesApiInternalPipelinesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>>
  >;
export type ListRegisteredPipelinesApiInternalPipelinesGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListRegisteredPipelinesApiInternalPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRegisteredPipelinesApiInternalPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRegisteredPipelinesApiInternalPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Registered Pipelines
 */

export function useListRegisteredPipelinesApiInternalPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRegisteredPipelinesApiInternalPipelinesGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListRegisteredPipelinesApiInternalPipelinesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse200 = {
  data: PipelineGrantListResponse;
  status: 200;
};

export type listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponseSuccess =
  listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse200 & {
    headers: Headers;
  };
export type listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponseError =
  listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse422 & {
    headers: Headers;
  };

export type listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse =
  | listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponseSuccess
  | listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponseError;

export const getListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/pipelines`;
};

/**
 * Staff: the batch pipelines granted to a team.
 * @summary List Team Pipelines
 */
export const listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse> => {
  return orvalFetch<listTeamPipelinesApiInternalTeamsTeamIdPipelinesGetResponse>(
    getListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetQueryKey = (
  teamId: string,
) => {
  return [`/api/internal/teams/${teamId}/pipelines`] as const;
};

export const getListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetQueryKey(teamId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
      >
    > = ({ signal }) =>
      listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet(teamId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
    >
  >;
export type ListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTeamPipelinesApiInternalTeamsTeamIdPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamPipelinesApiInternalTeamsTeamIdPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamPipelinesApiInternalTeamsTeamIdPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Team Pipelines
 */

export function useListTeamPipelinesApiInternalTeamsTeamIdPipelinesGet<
  TData = Awaited<
    ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamPipelinesApiInternalTeamsTeamIdPipelinesGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTeamPipelinesApiInternalTeamsTeamIdPipelinesGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse200 =
  {
    data: PipelineGrantItem;
    status: 200;
  };

export type grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponseSuccess =
  grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse200 & {
    headers: Headers;
  };
export type grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponseError =
  grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse422 & {
    headers: Headers;
  };

export type grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse =

    | grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponseSuccess
    | grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponseError;

export const getGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutUrl =
  (teamId: string, pipeline: string) => {
    return `/api/internal/teams/${teamId}/pipelines/${pipeline}`;
  };

/**
 * Staff: let a team submit batches to a pipeline. Idempotent.
 *
 * The team must exist in Keycloak: a grant for a mistyped id would sit
 * dormant until something else received that id.
 * @summary Grant Team Pipeline
 */
export const grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut =
  async (
    teamId: string,
    pipeline: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse> => {
    return orvalFetch<grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutResponse>(
      getGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutUrl(
        teamId,
        pipeline,
      ),
      {
        ...options,
        method: "PUT",
      },
    );
  };

export const getGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationKey =
  () =>
    ["grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut"] as const;

export const getGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut
        >
      >,
      TError,
      GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut
      >
    >,
    TError,
    GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut
        >
      >,
      GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationVariables
    > = (props) => {
      const { teamId, pipeline } = props ?? {};

      return grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut(
        teamId,
        pipeline,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut
      >
    >
  >;

export type GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationError =
  ErrorType<HTTPValidationError>;
export type GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationVariables =
  { teamId: string; pipeline: string };

/**
 * @summary Grant Team Pipeline
 */
export const useGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut
        >
      >,
      TError,
      GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof grantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePut
    >
  >,
  TError,
  GrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationVariables,
  TContext
> => {
  return useMutation(
    getGrantTeamPipelineApiInternalTeamsTeamIdPipelinesPipelinePutMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse200 =
  {
    data: PipelineGrantItem;
    status: 200;
  };

export type revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponseSuccess =
  revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse200 & {
    headers: Headers;
  };
export type revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponseError =
  revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse422 & {
    headers: Headers;
  };

export type revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse =

    | revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponseSuccess
    | revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponseError;

export const getRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteUrl =
  (teamId: string, pipeline: string) => {
    return `/api/internal/teams/${teamId}/pipelines/${pipeline}`;
  };

/**
 * Staff: revoke a grant. New submits 404; a queued or requeued batch
 * fails when its worker starts; a batch already running finishes.
 * @summary Revoke Team Pipeline
 */
export const revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete =
  async (
    teamId: string,
    pipeline: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse> => {
    return orvalFetch<revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteResponse>(
      getRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteUrl(
        teamId,
        pipeline,
      ),
      {
        ...options,
        method: "DELETE",
      },
    );
  };

export const getRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationKey =
  () =>
    [
      "revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete",
    ] as const;

export const getRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete
        >
      >,
      TError,
      RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete
      >
    >,
    TError,
    RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete
        >
      >,
      RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationVariables
    > = (props) => {
      const { teamId, pipeline } = props ?? {};

      return revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete(
        teamId,
        pipeline,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete
      >
    >
  >;

export type RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationVariables =
  { teamId: string; pipeline: string };

/**
 * @summary Revoke Team Pipeline
 */
export const useRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete
          >
        >,
        TError,
        RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof revokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDelete
      >
    >,
    TError,
    RevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationVariables,
    TContext
  > => {
    return useMutation(
      getRevokeTeamPipelineApiInternalTeamsTeamIdPipelinesPipelineDeleteMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type getTeamBillingApiInternalTeamsTeamIdBillingGetResponse200 = {
  data: TeamBillingAdminResponse;
  status: 200;
};

export type getTeamBillingApiInternalTeamsTeamIdBillingGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTeamBillingApiInternalTeamsTeamIdBillingGetResponseSuccess =
  getTeamBillingApiInternalTeamsTeamIdBillingGetResponse200 & {
    headers: Headers;
  };
export type getTeamBillingApiInternalTeamsTeamIdBillingGetResponseError =
  getTeamBillingApiInternalTeamsTeamIdBillingGetResponse422 & {
    headers: Headers;
  };

export type getTeamBillingApiInternalTeamsTeamIdBillingGetResponse =
  | getTeamBillingApiInternalTeamsTeamIdBillingGetResponseSuccess
  | getTeamBillingApiInternalTeamsTeamIdBillingGetResponseError;

export const getGetTeamBillingApiInternalTeamsTeamIdBillingGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/billing`;
};

/**
 * Staff: a team's billing config and its unpriced gap (TRA-1163).
 *
 * Read-only, straight from the gateway: the billing block as the nightly
 * cycle reads it, plus the last 30 days of per-model usage priced by the
 * gateway, so "why is this team's spend blank?" is answered here instead
 * of by dumping KV. A model is priced by its own entry in the block or,
 * failing that, by the catalog list price of the slug it calls
 * (TRA-1282), so the priced models include catalog-priced ones and say
 * which. Traffic the gateway could not price is the gap: it is never
 * invoiced and the cycle alerts on it every night.
 * @summary Get Team Billing
 */
export const getTeamBillingApiInternalTeamsTeamIdBillingGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTeamBillingApiInternalTeamsTeamIdBillingGetResponse> => {
  return orvalFetch<getTeamBillingApiInternalTeamsTeamIdBillingGetResponse>(
    getGetTeamBillingApiInternalTeamsTeamIdBillingGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTeamBillingApiInternalTeamsTeamIdBillingGetQueryKey = (
  teamId: string,
) => {
  return [`/api/internal/teams/${teamId}/billing`] as const;
};

export const getGetTeamBillingApiInternalTeamsTeamIdBillingGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTeamBillingApiInternalTeamsTeamIdBillingGetQueryKey(teamId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>>
  > = ({ signal }) =>
    getTeamBillingApiInternalTeamsTeamIdBillingGet(teamId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: teamId !== null && teamId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamBillingApiInternalTeamsTeamIdBillingGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>>
  >;
export type GetTeamBillingApiInternalTeamsTeamIdBillingGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamBillingApiInternalTeamsTeamIdBillingGet<
  TData = Awaited<
    ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamBillingApiInternalTeamsTeamIdBillingGet<
  TData = Awaited<
    ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamBillingApiInternalTeamsTeamIdBillingGet<
  TData = Awaited<
    ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Billing
 */

export function useGetTeamBillingApiInternalTeamsTeamIdBillingGet<
  TData = Awaited<
    ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTeamBillingApiInternalTeamsTeamIdBillingGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamBillingApiInternalTeamsTeamIdBillingGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listTeamModelsApiInternalTeamsTeamIdModelsGetResponse200 = {
  data: TeamModelsAdminResponse;
  status: 200;
};

export type listTeamModelsApiInternalTeamsTeamIdModelsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTeamModelsApiInternalTeamsTeamIdModelsGetResponseSuccess =
  listTeamModelsApiInternalTeamsTeamIdModelsGetResponse200 & {
    headers: Headers;
  };
export type listTeamModelsApiInternalTeamsTeamIdModelsGetResponseError =
  listTeamModelsApiInternalTeamsTeamIdModelsGetResponse422 & {
    headers: Headers;
  };

export type listTeamModelsApiInternalTeamsTeamIdModelsGetResponse =
  | listTeamModelsApiInternalTeamsTeamIdModelsGetResponseSuccess
  | listTeamModelsApiInternalTeamsTeamIdModelsGetResponseError;

export const getListTeamModelsApiInternalTeamsTeamIdModelsGetUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/models`;
};

/**
 * Staff: a team's models, each with where its route sends traffic.
 *
 * Runs the same gateway sync as the customer's own list (routes with no
 * row are imported, rows with no route are pruned), so the page shows
 * what the gateway serves. A team with no gateway team has no rows; the
 * first create provisions one.
 * @summary List Team Models
 */
export const listTeamModelsApiInternalTeamsTeamIdModelsGet = async (
  teamId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTeamModelsApiInternalTeamsTeamIdModelsGetResponse> => {
  return orvalFetch<listTeamModelsApiInternalTeamsTeamIdModelsGetResponse>(
    getListTeamModelsApiInternalTeamsTeamIdModelsGetUrl(teamId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTeamModelsApiInternalTeamsTeamIdModelsGetQueryKey = (
  teamId: string,
) => {
  return [`/api/internal/teams/${teamId}/models`] as const;
};

export const getListTeamModelsApiInternalTeamsTeamIdModelsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTeamModelsApiInternalTeamsTeamIdModelsGetQueryKey(teamId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>>
  > = ({ signal }) =>
    listTeamModelsApiInternalTeamsTeamIdModelsGet(teamId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: teamId !== null && teamId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTeamModelsApiInternalTeamsTeamIdModelsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>>
  >;
export type ListTeamModelsApiInternalTeamsTeamIdModelsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTeamModelsApiInternalTeamsTeamIdModelsGet<
  TData = Awaited<
    ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamModelsApiInternalTeamsTeamIdModelsGet<
  TData = Awaited<
    ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamModelsApiInternalTeamsTeamIdModelsGet<
  TData = Awaited<
    ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Team Models
 */

export function useListTeamModelsApiInternalTeamsTeamIdModelsGet<
  TData = Awaited<
    ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTeamModelsApiInternalTeamsTeamIdModelsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTeamModelsApiInternalTeamsTeamIdModelsGetQueryOptions(
      teamId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createTeamModelApiInternalTeamsTeamIdModelsPostResponse201 = {
  data: ModelResponse;
  status: 201;
};

export type createTeamModelApiInternalTeamsTeamIdModelsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createTeamModelApiInternalTeamsTeamIdModelsPostResponseSuccess =
  createTeamModelApiInternalTeamsTeamIdModelsPostResponse201 & {
    headers: Headers;
  };
export type createTeamModelApiInternalTeamsTeamIdModelsPostResponseError =
  createTeamModelApiInternalTeamsTeamIdModelsPostResponse422 & {
    headers: Headers;
  };

export type createTeamModelApiInternalTeamsTeamIdModelsPostResponse =
  | createTeamModelApiInternalTeamsTeamIdModelsPostResponseSuccess
  | createTeamModelApiInternalTeamsTeamIdModelsPostResponseError;

export const getCreateTeamModelApiInternalTeamsTeamIdModelsPostUrl = (
  teamId: string,
) => {
  return `/api/internal/teams/${teamId}/models`;
};

/**
 * Staff: add a model to a team, catalog-backed or a custom endpoint.
 *
 * The team must exist in Keycloak, since the create provisions a gateway
 * team and key for it when it has none.
 * @summary Create Team Model
 */
export const createTeamModelApiInternalTeamsTeamIdModelsPost = async (
  teamId: string,
  modelCreate: ModelCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createTeamModelApiInternalTeamsTeamIdModelsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createTeamModelApiInternalTeamsTeamIdModelsPostResponse>(
    getCreateTeamModelApiInternalTeamsTeamIdModelsPostUrl(teamId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(modelCreate),
    },
  );
};

export const getCreateTeamModelApiInternalTeamsTeamIdModelsPostMutationKey =
  () => ["createTeamModelApiInternalTeamsTeamIdModelsPost"] as const;

export const getCreateTeamModelApiInternalTeamsTeamIdModelsPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTeamModelApiInternalTeamsTeamIdModelsPost>
      >,
      TError,
      CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createTeamModelApiInternalTeamsTeamIdModelsPost>>,
    TError,
    CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getCreateTeamModelApiInternalTeamsTeamIdModelsPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createTeamModelApiInternalTeamsTeamIdModelsPost>
      >,
      CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationVariables
    > = (props) => {
      const { teamId, data } = props ?? {};

      return createTeamModelApiInternalTeamsTeamIdModelsPost(
        teamId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTeamModelApiInternalTeamsTeamIdModelsPost>>
  >;
export type CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationBody =
  ModelCreate;
export type CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationVariables = {
  teamId: string;
  data: ModelCreate;
};

/**
 * @summary Create Team Model
 */
export const useCreateTeamModelApiInternalTeamsTeamIdModelsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTeamModelApiInternalTeamsTeamIdModelsPost>
      >,
      TError,
      CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTeamModelApiInternalTeamsTeamIdModelsPost>>,
  TError,
  CreateTeamModelApiInternalTeamsTeamIdModelsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateTeamModelApiInternalTeamsTeamIdModelsPostMutationOptions(options),
    queryClient,
  );
};
export type updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse200 =
  {
    data: ModelResponse;
    status: 200;
  };

export type updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponseSuccess =
  updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse200 & {
    headers: Headers;
  };
export type updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponseError =
  updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse422 & {
    headers: Headers;
  };

export type updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse =
  | updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponseSuccess
  | updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponseError;

export const getUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchUrl = (
  teamId: string,
  modelId: string,
) => {
  return `/api/internal/teams/${teamId}/models/${modelId}`;
};

/**
 * Staff: rename, repoint, or set the fallback chain of a team's model.
 * @summary Update Team Model
 */
export const updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch = async (
  teamId: string,
  modelId: string,
  modelUpdate: ModelUpdate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchResponse>(
    getUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchUrl(
      teamId,
      modelId,
    ),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(modelUpdate),
    },
  );
};

export const getUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationKey =
  () => ["updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch"] as const;

export const getUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch
        >
      >,
      TError,
      UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch>
    >,
    TError,
    UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch
        >
      >,
      UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationVariables
    > = (props) => {
      const { teamId, modelId, data } = props ?? {};

      return updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch(
        teamId,
        modelId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch>
    >
  >;
export type UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationBody =
  ModelUpdate;
export type UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationVariables =
  { teamId: string; modelId: string; data: ModelUpdate };

/**
 * @summary Update Team Model
 */
export const useUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch
        >
      >,
      TError,
      UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTeamModelApiInternalTeamsTeamIdModelsModelIdPatch>
  >,
  TError,
  UpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateTeamModelApiInternalTeamsTeamIdModelsModelIdPatchMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse200 =
  {
    data: DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete200;
    status: 200;
  };

export type deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponseSuccess =
  deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse200 & {
    headers: Headers;
  };
export type deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponseError =
  deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse422 & {
    headers: Headers;
  };

export type deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse =
  | deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponseSuccess
  | deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponseError;

export const getDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteUrl = (
  teamId: string,
  modelId: string,
) => {
  return `/api/internal/teams/${teamId}/models/${modelId}`;
};

/**
 * Staff: delete a team's model and its gateway route.
 * @summary Delete Team Model
 */
export const deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete = async (
  teamId: string,
  modelId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse> => {
  return orvalFetch<deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteResponse>(
    getDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteUrl(
      teamId,
      modelId,
    ),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationKey =
  () => ["deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete"] as const;

export const getDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete
        >
      >,
      TError,
      DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete
      >
    >,
    TError,
    DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete
        >
      >,
      DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationVariables
    > = (props) => {
      const { teamId, modelId } = props ?? {};

      return deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete(
        teamId,
        modelId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete
      >
    >
  >;

export type DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationVariables =
  { teamId: string; modelId: string };

/**
 * @summary Delete Team Model
 */
export const useDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete
        >
      >,
      TError,
      DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteTeamModelApiInternalTeamsTeamIdModelsModelIdDelete>
  >,
  TError,
  DeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteTeamModelApiInternalTeamsTeamIdModelsModelIdDeleteMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse200 =
  {
    data: ModelResponse;
    status: 200;
  };

export type setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponseSuccess =
  setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse200 & {
    headers: Headers;
  };
export type setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponseError =
  setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse422 & {
    headers: Headers;
  };

export type setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse =

    | setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponseSuccess
    | setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponseError;

export const getSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostUrl =
  (teamId: string, modelId: string) => {
    return `/api/internal/teams/${teamId}/models/${modelId}/default`;
  };

/**
 * Staff: make one of a team's models its default, the one its nightly
 * evals score (TRA-1215).
 * @summary Set Team Default Model
 */
export const setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost =
  async (
    teamId: string,
    modelId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse> => {
    return orvalFetch<setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostResponse>(
      getSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostUrl(
        teamId,
        modelId,
      ),
      {
        ...options,
        method: "POST",
      },
    );
  };

export const getSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationKey =
  () =>
    [
      "setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost",
    ] as const;

export const getSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost
        >
      >,
      TError,
      SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost
      >
    >,
    TError,
    SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost
        >
      >,
      SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationVariables
    > = (props) => {
      const { teamId, modelId } = props ?? {};

      return setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost(
        teamId,
        modelId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost
      >
    >
  >;

export type SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationError =
  ErrorType<HTTPValidationError>;
export type SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationVariables =
  { teamId: string; modelId: string };

/**
 * @summary Set Team Default Model
 */
export const useSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost
          >
        >,
        TError,
        SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPost
      >
    >,
    TError,
    SetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getSetTeamDefaultModelApiInternalTeamsTeamIdModelsModelIdDefaultPostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse200 =
  {
    data: FallbackOptionsResponse;
    status: 200;
  };

export type getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponseSuccess =
  getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse200 & {
    headers: Headers;
  };
export type getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponseError =
  getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse422 & {
    headers: Headers;
  };

export type getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse =

    | getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponseSuccess
    | getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponseError;

export const getGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetUrl =
  (teamId: string, modelId: string) => {
    return `/api/internal/teams/${teamId}/models/${modelId}/fallback-options`;
  };

/**
 * Staff: what the edit dialog needs for one of a team's models.
 * @summary Get Team Model Fallback Options
 */
export const getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet =
  async (
    teamId: string,
    modelId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse> => {
    return orvalFetch<getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetResponse>(
      getGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetUrl(
        teamId,
        modelId,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };

export const getGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetQueryKey =
  (teamId: string, modelId: string) => {
    return [
      `/api/internal/teams/${teamId}/models/${modelId}/fallback-options`,
    ] as const;
  };

export const getGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
      >
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    teamId: string,
    modelId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetQueryKey(
        teamId,
        modelId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
        >
      >
    > = ({ signal }) =>
      getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet(
        teamId,
        modelId,
        { signal, ...requestOptions },
      );

    return {
      queryKey,
      queryFn,
      enabled:
        teamId !== null &&
        teamId !== undefined &&
        modelId !== null &&
        modelId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
      >
    >
  >;
export type GetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  modelId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Model Fallback Options
 */

export function useGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet<
  TData = Awaited<
    ReturnType<
      typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
    >
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  teamId: string,
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTeamModelFallbackOptionsApiInternalTeamsTeamIdModelsModelIdFallbackOptionsGetQueryOptions(
      teamId,
      modelId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse201 =
  {
    data: ModelResponse;
    status: 201;
  };

export type addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponseSuccess =
  addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse201 & {
    headers: Headers;
  };
export type addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponseError =
  addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse422 & {
    headers: Headers;
  };

export type addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse =

    | addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponseSuccess
    | addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponseError;

export const getAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostUrl =
  (teamId: string, modelId: string) => {
    return `/api/internal/teams/${teamId}/models/${modelId}/aliases`;
  };

/**
 * Staff: add a second slug that resolves to a team's model.
 * @summary Add Team Model Alias
 */
export const addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost =
  async (
    teamId: string,
    modelId: string,
    modelAliasCreate: ModelAliasCreate,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostResponse>(
      getAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostUrl(
        teamId,
        modelId,
      ),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(modelAliasCreate),
      },
    );
  };

export const getAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationKey =
  () =>
    [
      "addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost",
    ] as const;

export const getAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost
        >
      >,
      TError,
      AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost
      >
    >,
    TError,
    AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost
        >
      >,
      AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationVariables
    > = (props) => {
      const { teamId, modelId, data } = props ?? {};

      return addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost(
        teamId,
        modelId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost
      >
    >
  >;
export type AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationBody =
  ModelAliasCreate;
export type AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationError =
  ErrorType<HTTPValidationError>;
export type AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationVariables =
  { teamId: string; modelId: string; data: ModelAliasCreate };

/**
 * @summary Add Team Model Alias
 */
export const useAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost
          >
        >,
        TError,
        AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPost
      >
    >,
    TError,
    AddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getAddTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesPostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse200 =
  {
    data: ModelResponse;
    status: 200;
  };

export type removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponseSuccess =
  removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse200 & {
    headers: Headers;
  };
export type removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponseError =
  removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse422 & {
    headers: Headers;
  };

export type removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse =

    | removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponseSuccess
    | removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponseError;

export const getRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteUrl =
  (teamId: string, modelId: string, slug: string) => {
    return `/api/internal/teams/${teamId}/models/${modelId}/aliases/${slug}`;
  };

/**
 * Staff: remove an alias from a team's model.
 * @summary Remove Team Model Alias
 */
export const removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete =
  async (
    teamId: string,
    modelId: string,
    slug: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse> => {
    return orvalFetch<removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteResponse>(
      getRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteUrl(
        teamId,
        modelId,
        slug,
      ),
      {
        ...options,
        method: "DELETE",
      },
    );
  };

export const getRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationKey =
  () =>
    [
      "removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete",
    ] as const;

export const getRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete
        >
      >,
      TError,
      RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete
      >
    >,
    TError,
    RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete
        >
      >,
      RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationVariables
    > = (props) => {
      const { teamId, modelId, slug } = props ?? {};

      return removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete(
        teamId,
        modelId,
        slug,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete
      >
    >
  >;

export type RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationVariables =
  { teamId: string; modelId: string; slug: string };

/**
 * @summary Remove Team Model Alias
 */
export const useRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete
          >
        >,
        TError,
        RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDelete
      >
    >,
    TError,
    RemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationVariables,
    TContext
  > => {
    return useMutation(
      getRemoveTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugDeleteMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse200 =
  {
    data: ModelResponse;
    status: 200;
  };

export type promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponseSuccess =
  promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse200 & {
    headers: Headers;
  };
export type promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponseError =
  promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse422 & {
    headers: Headers;
  };

export type promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse =

    | promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponseSuccess
    | promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponseError;

export const getPromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostUrl =
  (teamId: string, modelId: string, slug: string) => {
    return `/api/internal/teams/${teamId}/models/${modelId}/aliases/${slug}/promote`;
  };

/**
 * Staff: make an alias the primary slug of a team's model.
 * @summary Promote Team Model Alias
 */
export const promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost =
  async (
    teamId: string,
    modelId: string,
    slug: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse> => {
    return orvalFetch<promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostResponse>(
      getPromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostUrl(
        teamId,
        modelId,
        slug,
      ),
      {
        ...options,
        method: "POST",
      },
    );
  };

export const getPromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationKey =
  () =>
    [
      "promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost",
    ] as const;

export const getPromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost
        >
      >,
      TError,
      PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost
      >
    >,
    TError,
    PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getPromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost
        >
      >,
      PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationVariables
    > = (props) => {
      const { teamId, modelId, slug } = props ?? {};

      return promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost(
        teamId,
        modelId,
        slug,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost
      >
    >
  >;

export type PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationError =
  ErrorType<HTTPValidationError>;
export type PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationVariables =
  { teamId: string; modelId: string; slug: string };

/**
 * @summary Promote Team Model Alias
 */
export const usePromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost
          >
        >,
        TError,
        PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof promoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePost
      >
    >,
    TError,
    PromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationVariables,
    TContext
  > => {
    return useMutation(
      getPromoteTeamModelAliasApiInternalTeamsTeamIdModelsModelIdAliasesSlugPromotePostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type listCatalogApiInternalCatalogGetResponse200 = {
  data: CatalogResponse;
  status: 200;
};

export type listCatalogApiInternalCatalogGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listCatalogApiInternalCatalogGetResponseSuccess =
  listCatalogApiInternalCatalogGetResponse200 & {
    headers: Headers;
  };
export type listCatalogApiInternalCatalogGetResponseError =
  listCatalogApiInternalCatalogGetResponse422 & {
    headers: Headers;
  };

export type listCatalogApiInternalCatalogGetResponse =
  | listCatalogApiInternalCatalogGetResponseSuccess
  | listCatalogApiInternalCatalogGetResponseError;

export const getListCatalogApiInternalCatalogGetUrl = () => {
  return `/api/internal/catalog`;
};

/**
 * Every catalog row, active or deprecated, with its gateway slot.
 * @summary List Catalog
 */
export const listCatalogApiInternalCatalogGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listCatalogApiInternalCatalogGetResponse> => {
  return orvalFetch<listCatalogApiInternalCatalogGetResponse>(
    getListCatalogApiInternalCatalogGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCatalogApiInternalCatalogGetQueryKey = () => {
  return [`/api/internal/catalog`] as const;
};

export const getListCatalogApiInternalCatalogGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCatalogApiInternalCatalogGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>
  > = ({ signal }) =>
    listCatalogApiInternalCatalogGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCatalogApiInternalCatalogGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>
>;
export type ListCatalogApiInternalCatalogGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListCatalogApiInternalCatalogGet<
  TData = Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
          TError,
          Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCatalogApiInternalCatalogGet<
  TData = Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
          TError,
          Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCatalogApiInternalCatalogGet<
  TData = Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Catalog
 */

export function useListCatalogApiInternalCatalogGet<
  TData = Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCatalogApiInternalCatalogGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCatalogApiInternalCatalogGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createCatalogModelApiInternalCatalogPostResponse201 = {
  data: CatalogModelView;
  status: 201;
};

export type createCatalogModelApiInternalCatalogPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createCatalogModelApiInternalCatalogPostResponseSuccess =
  createCatalogModelApiInternalCatalogPostResponse201 & {
    headers: Headers;
  };
export type createCatalogModelApiInternalCatalogPostResponseError =
  createCatalogModelApiInternalCatalogPostResponse422 & {
    headers: Headers;
  };

export type createCatalogModelApiInternalCatalogPostResponse =
  | createCatalogModelApiInternalCatalogPostResponseSuccess
  | createCatalogModelApiInternalCatalogPostResponseError;

export const getCreateCatalogModelApiInternalCatalogPostUrl = () => {
  return `/api/internal/catalog`;
};

/**
 * @summary Create Catalog Model
 */
export const createCatalogModelApiInternalCatalogPost = async (
  catalogModelCreate: CatalogModelCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createCatalogModelApiInternalCatalogPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createCatalogModelApiInternalCatalogPostResponse>(
    getCreateCatalogModelApiInternalCatalogPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(catalogModelCreate),
    },
  );
};

export const getCreateCatalogModelApiInternalCatalogPostMutationKey = () =>
  ["createCatalogModelApiInternalCatalogPost"] as const;

export const getCreateCatalogModelApiInternalCatalogPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCatalogModelApiInternalCatalogPost>>,
    TError,
    CreateCatalogModelApiInternalCatalogPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCatalogModelApiInternalCatalogPost>>,
  TError,
  CreateCatalogModelApiInternalCatalogPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCatalogModelApiInternalCatalogPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCatalogModelApiInternalCatalogPost>>,
    CreateCatalogModelApiInternalCatalogPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createCatalogModelApiInternalCatalogPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCatalogModelApiInternalCatalogPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createCatalogModelApiInternalCatalogPost>>
  >;
export type CreateCatalogModelApiInternalCatalogPostMutationBody =
  CatalogModelCreate;
export type CreateCatalogModelApiInternalCatalogPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateCatalogModelApiInternalCatalogPostMutationVariables = {
  data: CatalogModelCreate;
};

/**
 * @summary Create Catalog Model
 */
export const useCreateCatalogModelApiInternalCatalogPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCatalogModelApiInternalCatalogPost>>,
      TError,
      CreateCatalogModelApiInternalCatalogPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCatalogModelApiInternalCatalogPost>>,
  TError,
  CreateCatalogModelApiInternalCatalogPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateCatalogModelApiInternalCatalogPostMutationOptions(options),
    queryClient,
  );
};
export type probeCatalogModelApiInternalCatalogProbePostResponse200 = {
  data: CatalogProbeResponse;
  status: 200;
};

export type probeCatalogModelApiInternalCatalogProbePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type probeCatalogModelApiInternalCatalogProbePostResponseSuccess =
  probeCatalogModelApiInternalCatalogProbePostResponse200 & {
    headers: Headers;
  };
export type probeCatalogModelApiInternalCatalogProbePostResponseError =
  probeCatalogModelApiInternalCatalogProbePostResponse422 & {
    headers: Headers;
  };

export type probeCatalogModelApiInternalCatalogProbePostResponse =
  | probeCatalogModelApiInternalCatalogProbePostResponseSuccess
  | probeCatalogModelApiInternalCatalogProbePostResponseError;

export const getProbeCatalogModelApiInternalCatalogProbePostUrl = () => {
  return `/api/internal/catalog/probe`;
};

/**
 * Make one sample call to a provider model, the way a slot for it would.
 * @summary Probe Catalog Model
 */
export const probeCatalogModelApiInternalCatalogProbePost = async (
  catalogProbeRequest: CatalogProbeRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<probeCatalogModelApiInternalCatalogProbePostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<probeCatalogModelApiInternalCatalogProbePostResponse>(
    getProbeCatalogModelApiInternalCatalogProbePostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(catalogProbeRequest),
    },
  );
};

export const getProbeCatalogModelApiInternalCatalogProbePostMutationKey = () =>
  ["probeCatalogModelApiInternalCatalogProbePost"] as const;

export const getProbeCatalogModelApiInternalCatalogProbePostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof probeCatalogModelApiInternalCatalogProbePost>>,
    TError,
    ProbeCatalogModelApiInternalCatalogProbePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof probeCatalogModelApiInternalCatalogProbePost>>,
  TError,
  ProbeCatalogModelApiInternalCatalogProbePostMutationVariables,
  TContext
> => {
  const mutationKey =
    getProbeCatalogModelApiInternalCatalogProbePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof probeCatalogModelApiInternalCatalogProbePost>>,
    ProbeCatalogModelApiInternalCatalogProbePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return probeCatalogModelApiInternalCatalogProbePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProbeCatalogModelApiInternalCatalogProbePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof probeCatalogModelApiInternalCatalogProbePost>>
  >;
export type ProbeCatalogModelApiInternalCatalogProbePostMutationBody =
  CatalogProbeRequest;
export type ProbeCatalogModelApiInternalCatalogProbePostMutationError =
  ErrorType<HTTPValidationError>;
export type ProbeCatalogModelApiInternalCatalogProbePostMutationVariables = {
  data: CatalogProbeRequest;
};

/**
 * @summary Probe Catalog Model
 */
export const useProbeCatalogModelApiInternalCatalogProbePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof probeCatalogModelApiInternalCatalogProbePost>>,
      TError,
      ProbeCatalogModelApiInternalCatalogProbePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof probeCatalogModelApiInternalCatalogProbePost>>,
  TError,
  ProbeCatalogModelApiInternalCatalogProbePostMutationVariables,
  TContext
> => {
  return useMutation(
    getProbeCatalogModelApiInternalCatalogProbePostMutationOptions(options),
    queryClient,
  );
};
export type updateCatalogModelApiInternalCatalogModelIdPutResponse200 = {
  data: CatalogModelView;
  status: 200;
};

export type updateCatalogModelApiInternalCatalogModelIdPutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateCatalogModelApiInternalCatalogModelIdPutResponseSuccess =
  updateCatalogModelApiInternalCatalogModelIdPutResponse200 & {
    headers: Headers;
  };
export type updateCatalogModelApiInternalCatalogModelIdPutResponseError =
  updateCatalogModelApiInternalCatalogModelIdPutResponse422 & {
    headers: Headers;
  };

export type updateCatalogModelApiInternalCatalogModelIdPutResponse =
  | updateCatalogModelApiInternalCatalogModelIdPutResponseSuccess
  | updateCatalogModelApiInternalCatalogModelIdPutResponseError;

export const getUpdateCatalogModelApiInternalCatalogModelIdPutUrl = (
  modelId: string,
) => {
  return `/api/internal/catalog/${modelId}`;
};

/**
 * @summary Update Catalog Model
 */
export const updateCatalogModelApiInternalCatalogModelIdPut = async (
  modelId: string,
  catalogModelUpdate: CatalogModelUpdate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateCatalogModelApiInternalCatalogModelIdPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateCatalogModelApiInternalCatalogModelIdPutResponse>(
    getUpdateCatalogModelApiInternalCatalogModelIdPutUrl(modelId),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(catalogModelUpdate),
    },
  );
};

export const getUpdateCatalogModelApiInternalCatalogModelIdPutMutationKey =
  () => ["updateCatalogModelApiInternalCatalogModelIdPut"] as const;

export const getUpdateCatalogModelApiInternalCatalogModelIdPutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateCatalogModelApiInternalCatalogModelIdPut>
      >,
      TError,
      UpdateCatalogModelApiInternalCatalogModelIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateCatalogModelApiInternalCatalogModelIdPut>>,
    TError,
    UpdateCatalogModelApiInternalCatalogModelIdPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateCatalogModelApiInternalCatalogModelIdPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateCatalogModelApiInternalCatalogModelIdPut>
      >,
      UpdateCatalogModelApiInternalCatalogModelIdPutMutationVariables
    > = (props) => {
      const { modelId, data } = props ?? {};

      return updateCatalogModelApiInternalCatalogModelIdPut(
        modelId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCatalogModelApiInternalCatalogModelIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateCatalogModelApiInternalCatalogModelIdPut>>
  >;
export type UpdateCatalogModelApiInternalCatalogModelIdPutMutationBody =
  CatalogModelUpdate;
export type UpdateCatalogModelApiInternalCatalogModelIdPutMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateCatalogModelApiInternalCatalogModelIdPutMutationVariables = {
  modelId: string;
  data: CatalogModelUpdate;
};

/**
 * @summary Update Catalog Model
 */
export const useUpdateCatalogModelApiInternalCatalogModelIdPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateCatalogModelApiInternalCatalogModelIdPut>
      >,
      TError,
      UpdateCatalogModelApiInternalCatalogModelIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCatalogModelApiInternalCatalogModelIdPut>>,
  TError,
  UpdateCatalogModelApiInternalCatalogModelIdPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateCatalogModelApiInternalCatalogModelIdPutMutationOptions(options),
    queryClient,
  );
};
export type catalogModelImpactApiInternalCatalogModelIdImpactGetResponse200 = {
  data: CatalogImpactResponse;
  status: 200;
};

export type catalogModelImpactApiInternalCatalogModelIdImpactGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type catalogModelImpactApiInternalCatalogModelIdImpactGetResponseSuccess =
  catalogModelImpactApiInternalCatalogModelIdImpactGetResponse200 & {
    headers: Headers;
  };
export type catalogModelImpactApiInternalCatalogModelIdImpactGetResponseError =
  catalogModelImpactApiInternalCatalogModelIdImpactGetResponse422 & {
    headers: Headers;
  };

export type catalogModelImpactApiInternalCatalogModelIdImpactGetResponse =
  | catalogModelImpactApiInternalCatalogModelIdImpactGetResponseSuccess
  | catalogModelImpactApiInternalCatalogModelIdImpactGetResponseError;

export const getCatalogModelImpactApiInternalCatalogModelIdImpactGetUrl = (
  modelId: string,
) => {
  return `/api/internal/catalog/${modelId}/impact`;
};

/**
 * The user-Models that would lose their backing model on deprecation.
 * @summary Catalog Model Impact
 */
export const catalogModelImpactApiInternalCatalogModelIdImpactGet = async (
  modelId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<catalogModelImpactApiInternalCatalogModelIdImpactGetResponse> => {
  return orvalFetch<catalogModelImpactApiInternalCatalogModelIdImpactGetResponse>(
    getCatalogModelImpactApiInternalCatalogModelIdImpactGetUrl(modelId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getCatalogModelImpactApiInternalCatalogModelIdImpactGetQueryKey = (
  modelId: string,
) => {
  return [`/api/internal/catalog/${modelId}/impact`] as const;
};

export const getCatalogModelImpactApiInternalCatalogModelIdImpactGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(
    modelId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCatalogModelImpactApiInternalCatalogModelIdImpactGetQueryKey(modelId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
      >
    > = ({ signal }) =>
      catalogModelImpactApiInternalCatalogModelIdImpactGet(modelId, {
        signal,
        ...requestOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: modelId !== null && modelId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type CatalogModelImpactApiInternalCatalogModelIdImpactGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
    >
  >;
export type CatalogModelImpactApiInternalCatalogModelIdImpactGetQueryError =
  ErrorType<HTTPValidationError>;

export function useCatalogModelImpactApiInternalCatalogModelIdImpactGet<
  TData = Awaited<
    ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCatalogModelImpactApiInternalCatalogModelIdImpactGet<
  TData = Awaited<
    ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCatalogModelImpactApiInternalCatalogModelIdImpactGet<
  TData = Awaited<
    ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Catalog Model Impact
 */

export function useCatalogModelImpactApiInternalCatalogModelIdImpactGet<
  TData = Awaited<
    ReturnType<typeof catalogModelImpactApiInternalCatalogModelIdImpactGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof catalogModelImpactApiInternalCatalogModelIdImpactGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getCatalogModelImpactApiInternalCatalogModelIdImpactGetQueryOptions(
      modelId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse200 =
  {
    data: CatalogModelView;
    status: 200;
  };

export type deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponseSuccess =
  deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse200 & {
    headers: Headers;
  };
export type deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponseError =
  deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse422 & {
    headers: Headers;
  };

export type deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse =

    | deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponseSuccess
    | deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponseError;

export const getDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostUrl =
  (modelId: string) => {
    return `/api/internal/catalog/${modelId}/deprecate`;
  };

/**
 * @summary Deprecate Catalog Model
 */
export const deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost =
  async (
    modelId: string,
    catalogDeprecateRequest: CatalogDeprecateRequest,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Symbol.iterator in h) {
        return Object.fromEntries(
          Array.from(
            h as Iterable<Iterable<string>>,
            (entry) => Array.from(entry) as [string, string],
          ),
        );
      }
      const headers: Record<string, string | readonly string[]> = {};
      for (const [name, value] of Object.entries<
        string | readonly string[] | undefined
      >(h)) {
        if (value !== undefined) headers[name] = value;
      }
      return headers;
    };
    return orvalFetch<deprecateCatalogModelApiInternalCatalogModelIdDeprecatePostResponse>(
      getDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostUrl(
        modelId,
      ),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(catalogDeprecateRequest),
      },
    );
  };

export const getDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationKey =
  () =>
    ["deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost"] as const;

export const getDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost
        >
      >,
      TError,
      DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost
      >
    >,
    TError,
    DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost
        >
      >,
      DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationVariables
    > = (props) => {
      const { modelId, data } = props ?? {};

      return deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost(
        modelId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost
      >
    >
  >;
export type DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationBody =
  CatalogDeprecateRequest;
export type DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationError =
  ErrorType<HTTPValidationError>;
export type DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationVariables =
  { modelId: string; data: CatalogDeprecateRequest };

/**
 * @summary Deprecate Catalog Model
 */
export const useDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost
        >
      >,
      TError,
      DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deprecateCatalogModelApiInternalCatalogModelIdDeprecatePost
    >
  >,
  TError,
  DeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationVariables,
  TContext
> => {
  return useMutation(
    getDeprecateCatalogModelApiInternalCatalogModelIdDeprecatePostMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse200 =
  {
    data: CatalogModelView;
    status: 200;
  };

export type reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponseSuccess =
  reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse200 & {
    headers: Headers;
  };
export type reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponseError =
  reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse422 & {
    headers: Headers;
  };

export type reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse =

    | reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponseSuccess
    | reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponseError;

export const getReactivateCatalogModelApiInternalCatalogModelIdReactivatePostUrl =
  (modelId: string) => {
    return `/api/internal/catalog/${modelId}/reactivate`;
  };

/**
 * @summary Reactivate Catalog Model
 */
export const reactivateCatalogModelApiInternalCatalogModelIdReactivatePost =
  async (
    modelId: string,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse> => {
    return orvalFetch<reactivateCatalogModelApiInternalCatalogModelIdReactivatePostResponse>(
      getReactivateCatalogModelApiInternalCatalogModelIdReactivatePostUrl(
        modelId,
      ),
      {
        ...options,
        method: "POST",
      },
    );
  };

export const getReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationKey =
  () =>
    ["reactivateCatalogModelApiInternalCatalogModelIdReactivatePost"] as const;

export const getReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reactivateCatalogModelApiInternalCatalogModelIdReactivatePost
        >
      >,
      TError,
      ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reactivateCatalogModelApiInternalCatalogModelIdReactivatePost
      >
    >,
    TError,
    ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reactivateCatalogModelApiInternalCatalogModelIdReactivatePost
        >
      >,
      ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationVariables
    > = (props) => {
      const { modelId } = props ?? {};

      return reactivateCatalogModelApiInternalCatalogModelIdReactivatePost(
        modelId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reactivateCatalogModelApiInternalCatalogModelIdReactivatePost
      >
    >
  >;

export type ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationError =
  ErrorType<HTTPValidationError>;
export type ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationVariables =
  { modelId: string };

/**
 * @summary Reactivate Catalog Model
 */
export const useReactivateCatalogModelApiInternalCatalogModelIdReactivatePost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reactivateCatalogModelApiInternalCatalogModelIdReactivatePost
          >
        >,
        TError,
        ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reactivateCatalogModelApiInternalCatalogModelIdReactivatePost
      >
    >,
    TError,
    ReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationVariables,
    TContext
  > => {
    return useMutation(
      getReactivateCatalogModelApiInternalCatalogModelIdReactivatePostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
